import React from "react";
import { Footer, Navbar } from "components";
import AppRoutes from "routes";

function App() {
  return (
    <div className="overflow-hidden">
      {/* NavBar */}
      <div className="fixed top-0 z-50 w-full bg-black">
        <div className="relative ">
          <Navbar />
        </div>
      </div>
      <AppRoutes />
      <Footer />
    </div>
  );
}

export default App;
